<div class="tabs-container" [ngClass]="{ 'tabs-sticky': tabsSticky }">
    <div class="tabs content-contained" #tabContainer>
        <div class="tab" *ngFor="let tab of tabs" [ngClass]="{ active: tab.id === activeTab }" (click)="switchTab(tab.id)">{{tab.title}}</div>
    </div>
</div>
